import { Box } from '@mui/material';
import { SHARED_SOCIAL_PLATFORM_ICON_PATHS } from '@realadvisor/constants';

import type { SocialPlatform } from '../../../utils/urlValidation';

type SocialMediaIconProps = {
  type: SocialPlatform;
  size?: number;
};

const iconPaths: Record<SocialPlatform, string> = {
  ...SHARED_SOCIAL_PLATFORM_ICON_PATHS,
  tiktok:
    'M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.18 8.18 0 004.77 1.52V6.84a4.84 4.84 0 01-1-.15z',
  x: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
};

const iconColors: Record<SocialPlatform, string> = {
  instagram: 'linear-gradient(to top right, #FCAF45, #E1306C, #833AB4)',
  tiktok: '#000000',
  youtube: '#D32F2F',
  x: '#000000',
  facebook: '#1877F2',
  linkedin: '#0A66C2',
};

export const SocialIconList = ({
  socialIcons,
}: {
  socialIcons: SocialPlatform[];
}) =>
  socialIcons.length === 0 ? (
    <Box sx={{ color: 'text.secondary' }}>-</Box>
  ) : (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
      {socialIcons.map(iconType => (
        <SocialMediaIcon key={iconType} type={iconType} />
      ))}
    </Box>
  );

export const SocialMediaIcon = ({ type, size = 32 }: SocialMediaIconProps) => {
  const glyphSize = Math.round(size * 0.5);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        flexShrink: 0,
        color: 'text.secondary',
        borderRadius: '50%',
        overflow: 'hidden',
        bgcolor: 'grey.100',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <Box
        className="hover-bg"
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 1,
          transition: 'opacity 0.3s',
          ...(type === 'instagram'
            ? { background: iconColors[type] }
            : { bgcolor: iconColors[type] }),
        }}
      />
      <svg
        width={glyphSize}
        height={glyphSize}
        viewBox="0 0 24 24"
        fill="white"
        style={{
          position: 'relative',
          flexShrink: 0,
          transition: 'color 0.3s',
        }}
      >
        <path d={iconPaths[type]} />
      </svg>
    </Box>
  );
};
